import { GameSummaryLandscapeProperties } from "../landscape/GameSummaryLandscapeProperties";
/**
 * GameSummaryPortraitProperties.ts
 */
export class GameSummaryPortraitProperties extends GameSummaryLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.panelSpineProperties.position.set(512, 845);
    }
}
